"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _profile = require("@widget/profile");

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _Merchants = _interopRequireDefault(require("./Merchants"));

var _Logout = _interopRequireDefault(require("./Logout"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["onClick"];

function Dropdown(_ref) {
  var onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var getSelectedMerchant = function getSelectedMerchant() {
      return findMerchant(profile['merchant']['id']);
    };

    var findMerchant = function findMerchant(id) {
      return merchants.find(function (merchant) {
        return merchant['id'] === id;
      });
    };

    var handleChange = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(merchantId) {
        var activeMerchant, nextMerchant, isSuccess;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                activeMerchant = getSelectedMerchant();
                nextMerchant = findMerchant(merchantId);
                onClick();
                _context.next = 5;
                return dispatch((0, _profile.changeMerchant)(activeMerchant, nextMerchant, profile));

              case 5:
                isSuccess = _context.sent;

                if (isSuccess) {
                  navigate(process.env['PUBLIC_URL'] + '/');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleChange(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var dispatch = (0, _reactRedux.useDispatch)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var merchants = (0, _reactRedux.useSelector)(_profile.selectAvailableMerchants);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": props['data-locator']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['list']
    }, /*#__PURE__*/_react["default"].createElement(_Merchants["default"], {
      "data-locator": props['data-locator'],
      onChange: function onChange(id) {
        return handleChange(id);
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_Logout["default"], {
      "data-locator": props['data-locator']
    }))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Dropdown;
exports["default"] = _default;